import { getMonths } from 'src/common/utils/chartAxisLabelsUtils';

export const getDefaultBarChartLabels = (withEmptyLine?: boolean) =>
  getMonths('short').map((month) => `${month}${withEmptyLine ? '\n' : ''}`);
